import moment from 'moment'
const dateFilter = function(date) {
  if (date) {
    return moment(new Date(Number(date) || date)).format('YYYY-MM-DD HH:mm:ss')
  } else {
    return ''
  }
}

const ellipsisFilter = function(value, displayNum = 3) {
  value = String(value)
  if (value.length > displayNum) {
    return value.slice(0, 1) + '...'
  } else {
    return value
  }
}

function isString(val) {
  return typeof val === 'string'
}

export {
  dateFilter,
  ellipsisFilter
}



// WEBPACK FOOTER //
// ./src/lib/filter.js